<template>
  <div class="stepper-container">
    <div class="stepper">
      <div 
        v-for="step in totalSteps" 
        :key="step"
        class="step-wrapper"
        :class="{ 'last-step': step === totalSteps }"
      >
        <!-- Step Circle -->
        <div 
          class="step-circle"
          :class="{
            'completed': step <= currentStep,
            'inactive': step > currentStep
          }"
        >
          {{ step }}
        </div>
        
        <!-- Connecting Line (not shown for last step) -->
        <div 
          v-if="step < totalSteps"
          class="step-line"
          :class="{
            'completed': step < currentStep,
            'inactive': step >= currentStep
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepperComponent',
  props: {
    initialStep: {
      type: Number,
      default: 1,
      validator: function (value) {
        return value >= 1 && value <= 5
      }
    },
    totalSteps: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      currentStep: this.initialStep
    }
  },
  methods: {
    setStep(step) {
      if (step >= 1 && step <= this.totalSteps) {
        this.currentStep = step
        this.$emit('step-changed', this.currentStep)
      }
    }
  },
  watch: {
    initialStep: {
      immediate: true,
      handler(newVal) {
        this.currentStep = newVal
      }
    }
  }
}
</script>

<style scoped>
.stepper-container {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

.stepper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 40px;
}

.step-wrapper {
  display: flex;
  align-items: center;
  flex: 1;
}

.step-wrapper.last-step {
  flex: 0;
}

.step-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  transition: all 0.3s ease;
  flex-shrink: 0;
  z-index: 2;
  position: relative;
}

.step-circle.completed {
  background-color: #000;
  color: #fff;
  border: 2px solid #000;
}

.step-circle.inactive {
  background-color: #f5f5f5;
  color: #999;
  border: 2px solid #ddd;
}

.step-line {
  height: 2px;
  flex: 1;
  margin: 0 8px;
  transition: all 0.3s ease;
}

.step-line.completed {
  background-color: #000;
}

.step-line.inactive {
  background-color: #ddd;
}

/* Responsive Design */
@media (max-width: 768px) {
  .stepper-container {
    padding: 15px;
  }
  
  .step-circle {
    width: 35px;
    height: 35px;
    font-size: 14px;
  }
  
  .step-line {
    margin: 0 4px;
  }
}

@media (max-width: 480px) {
  .stepper-container {
    padding: 10px;
  }
  
  .step-circle {
    width: 30px;
    height: 30px;
    font-size: 12px;
  }
  
  .step-line {
    margin: 0 2px;
  }
}

/* Extra small screens */
@media (max-width: 320px) {
  .stepper {
    margin-bottom: 20px;
  }
  
  .step-circle {
    width: 28px;
    height: 28px;
    font-size: 11px;
  }
}
</style>